import React from 'react';
import './_footer.scss';

const Footer = () =>
  (<footer className="sticky-footer">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            Version 2.10 - 2026 - Week 1
          </div>
        </div>
      </footer>);

export default Footer;
